import { bucketForEntry } from '~/components/ActivityLogItem/bucketFor';
const searchableTextFor = (entry)=>{
    if (entry.isSentNotificationEntry()) {
        var _entry_invoiceNumber;
        const invoiceNumber = (_entry_invoiceNumber = entry.invoiceNumber()) !== null && _entry_invoiceNumber !== void 0 ? _entry_invoiceNumber : '';
        const deliveryText = entry.deliveries().map((delivery)=>{
            const recipient = delivery.recipient.name;
            if (delivery.channel.type === 'email') {
                const { address, subject, body } = delivery.channel.email;
                return "".concat(recipient, " ").concat(address, " ").concat(subject, " ").concat(body);
            }
            const { phoneNumber, body } = delivery.channel.sms;
            return "".concat(recipient, " ").concat(phoneNumber, " ").concat(body);
        }).join(' ');
        return "".concat(entry.state(), " ").concat(invoiceNumber, " ").concat(deliveryText);
    }
    if (entry.isInvoiceEntry()) {
        var _entry_formattedNumber, _entry_customerName, _entry_vendorName;
        return "".concat(entry.state(), " ").concat((_entry_formattedNumber = entry.formattedNumber()) !== null && _entry_formattedNumber !== void 0 ? _entry_formattedNumber : '', " ").concat((_entry_customerName = entry.customerName()) !== null && _entry_customerName !== void 0 ? _entry_customerName : '', " ").concat((_entry_vendorName = entry.vendorName()) !== null && _entry_vendorName !== void 0 ? _entry_vendorName : '');
    }
    if (entry.isAgreementEntry()) {
        var _entry_customerName1, _entry_vendorName1;
        return "".concat(entry.state(), " ").concat((_entry_customerName1 = entry.customerName()) !== null && _entry_customerName1 !== void 0 ? _entry_customerName1 : '', " ").concat((_entry_vendorName1 = entry.vendorName()) !== null && _entry_vendorName1 !== void 0 ? _entry_vendorName1 : '');
    }
    if (entry.isChargeEntry()) {
        var _entry_name, _entry_customerName2, _entry_vendorName2;
        return "".concat(entry.state(), " ").concat((_entry_name = entry.name()) !== null && _entry_name !== void 0 ? _entry_name : '', " ").concat((_entry_customerName2 = entry.customerName()) !== null && _entry_customerName2 !== void 0 ? _entry_customerName2 : '', " ").concat((_entry_vendorName2 = entry.vendorName()) !== null && _entry_vendorName2 !== void 0 ? _entry_vendorName2 : '');
    }
    if (entry.isServiceEntry()) {
        var _entry_name1, _entry_customerName3, _entry_vendorName3;
        return "".concat(entry.state(), " ").concat((_entry_name1 = entry.name()) !== null && _entry_name1 !== void 0 ? _entry_name1 : '', " ").concat((_entry_customerName3 = entry.customerName()) !== null && _entry_customerName3 !== void 0 ? _entry_customerName3 : '', " ").concat((_entry_vendorName3 = entry.vendorName()) !== null && _entry_vendorName3 !== void 0 ? _entry_vendorName3 : '');
    }
    return entry.state();
};
const passesSearch = (entry, searchLower)=>{
    if (searchLower === '') return true;
    return searchableTextFor(entry).toLowerCase().includes(searchLower);
};
const passesTypeFilter = (entry, appliedTypes)=>{
    if (appliedTypes.size === 0) return true;
    const bucket = bucketForEntry(entry);
    if (bucket == null) return false;
    return appliedTypes.has(bucket);
};
const passesToggle = (entry, showNotifications)=>{
    if (showNotifications) return true;
    return !entry.isSentNotificationEntry();
};
export const filterEntries = (entries, param)=>{
    let { searchCommitted, appliedTypes, showNotifications } = param;
    const searchLower = searchCommitted.trim().toLowerCase();
    return entries.filter((entry)=>passesTypeFilter(entry, appliedTypes) && passesToggle(entry, showNotifications) && passesSearch(entry, searchLower));
};
